import { useEffect, useRef, FC } from 'react';
import PlusIcon from '../../../assets/icons/plus.svg?react';
import {
  addQuestionFiles,
  MAX_FILES_PER_QUESTION,
  removeQuestionFiles,
  useCurrentAnswer,
  useCurrentQuestion,
} from '../../../services/inspection';
import { AnswerState, Question } from '../types';
import styles from './ImageInput.module.css';
import { AddPhotoButtonText, HiddenImageInput, Image } from './views';

export const ImageInput: FC = () => {
  const { id } = useCurrentQuestion() as Question;
  const { files } = useCurrentAnswer() as AnswerState;

  const addMoreRef = useRef<HTMLLabelElement>(null);
  const prevCount = useRef<number>(files.length);

  useEffect(() => {
    if (prevCount.current < files.length) {
      addMoreRef.current?.scrollIntoView?.();
    }
    prevCount.current = files.length;
  }, [files.length]);

  return (
    <>
      {files.length > 0 && (
        <div className={styles.galleryContainer}>
          <div className={styles.gallery}>
            {files.map((image, index) => (
              <Image
                key={index}
                image={image}
                onClose={() => removeQuestionFiles(id, index)}
              />
            ))}
            {files.length < MAX_FILES_PER_QUESTION && (
              <label ref={addMoreRef} className={styles.addAnotherPhoto}>
                <HiddenImageInput
                  onChange={(e) => addQuestionFiles(id, e.target.files)}
                />
                <PlusIcon className={styles.plus} />
              </label>
            )}
          </div>
        </div>
      )}
      {!files.length && (
        <AddPhotoButtonText>
          <HiddenImageInput
            onChange={(e) => addQuestionFiles(id, e.target.files)}
          />
        </AddPhotoButtonText>
      )}
    </>
  );
};
